/* eslint-disable import/no-unresolved */
import AuditLogsColumnConfig from 'views/Rules/common/AuditLogsColumnConfig';
import FFIEC009AuditLog from '../components/FFIEC009AuditLog';

const FFIEC009AuditLogs = ({ data }) => {
    const ffiec009Columns = AuditLogsColumnConfig;

    return (
        <FFIEC009AuditLog
            data={data}
            columns={ffiec009Columns}
        />
    );
};
export default FFIEC009AuditLogs;
